import React, { useState } from "react";
import { Info } from "lucide-react";

const AssessmentProfileAbout = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <div className="mt-8 bg-white shadow overflow-auto sm:rounded-lg">
        <div className="px-4 py-5 sm:px-6 bg-gradient-to-r from-indigo-50 to-white border-b border-gray-200 flex justify-between items-start">
          <div>
            <h3 className="text-lg leading-6 font-medium text-gray-900 flex items-center">
              <Info className="mr-3 h-4 w-4" />
              About Assessment Profiles
            </h3>
            <p className="mt-1 max-w-2xl text-sm text-gray-500">
              Create reusable templates for consistent candidate evaluation
            </p>
          </div>
          <button
            onClick={openModal}
            className="inline-flex items-center px-3 py-1.5 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 mr-1.5 text-indigo-500"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
                clipRule="evenodd"
              ></path>
            </svg>
            Learn More
          </button>
        </div>
        <div className="border-t border-gray-200">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-6">
            <div className="bg-white border border-gray-100 rounded-lg p-5 shadow-sm transition duration-200 hover:shadow-md hover:border-indigo-200 hover:-translate-y-1">
              <div className="flex items-center mb-3">
                <div className="flex-shrink-0 h-10 w-10 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z"></path>
                  </svg>
                </div>
                <h3 className="ml-3 text-sm font-medium text-gray-900">
                  Save Time &amp; Effort
                </h3>
              </div>
              <p className="text-sm text-gray-600">
                Create once and apply to multiple jobs to ensure consistent
                evaluation standards across similar positions.
              </p>
            </div>

            <div className="bg-white border border-gray-100 rounded-lg p-5 shadow-sm transition duration-200 hover:shadow-md hover:border-indigo-200 hover:-translate-y-1">
              <div className="flex items-center mb-3">
                <div className="flex-shrink-0 h-10 w-10 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </div>
                <h3 className="ml-3 text-sm font-medium text-gray-900">
                  Maintain Consistency
                </h3>
              </div>
              <p className="text-sm text-gray-600">
                Ensure all candidates for similar positions are evaluated
                against the same criteria and standards.
              </p>
            </div>

            <div className="bg-white border border-gray-100 rounded-lg p-5 shadow-sm transition duration-200 hover:shadow-md hover:border-indigo-200 hover:-translate-y-1">
              <div className="flex items-center mb-3">
                <div className="flex-shrink-0 h-10 w-10 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z"></path>
                  </svg>
                </div>
                <h3 className="ml-3 text-sm font-medium text-gray-900">
                  Flexible Configuration
                </h3>
              </div>
              <p className="text-sm text-gray-600">
                Fine-tune question types, topics, and scoring criteria to match
                specific job requirements.
              </p>
            </div>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center overflow-y-auto h-vh">
          <div className="min-h-screen bg-white rounded-lg p-6 max-w-3xl w-full mx-4 transform transition-all duration-300 ease-out">
            <div className="flex justify-between items-start mb-4">
              <h2 className="text-xl font-bold text-gray-900 flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 mr-2 text-indigo-600"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                About Assessment Profiles
              </h2>
              <button
                onClick={closeModal}
                className="text-gray-400 hover:text-gray-500 transition-colors"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  ></path>
                </svg>
              </button>
            </div>

            <div className="prose max-w-none">
              <p>
                Assessment Profiles serve as reusable templates that define the
                structure and content of candidate assessments for similar job
                types.
              </p>

              <div className="bg-indigo-50 border border-indigo-200 rounded-md p-4 mt-4">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <svg
                      className="h-5 w-5 text-indigo-400"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </div>
                  <div className="ml-3">
                    <h3 className="text-sm font-medium text-indigo-800">
                      Best Practices
                    </h3>
                    <div className="mt-2 text-sm text-indigo-700">
                      <ul className="list-disc pl-5 space-y-1">
                        <li>
                          Create separate profiles for different skill levels
                          (e.g., entry-level, mid-level, senior)
                        </li>
                        <li>
                          Balance technical questions with soft skills
                          assessment
                        </li>
                        <li>
                          Regularly review and update profiles based on hiring
                          outcomes
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <h3 className="text-lg font-medium text-gray-900 mt-6 mb-3">
                Key Benefits
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <ul className="list-disc pl-5 space-y-1 text-sm text-gray-700">
                  <li>Create once, apply to multiple job postings</li>
                  <li>Maintain consistency across similar positions</li>
                  <li>Customize profiles for different job categories</li>
                  <li>Share best practices across your organization</li>
                </ul>
                <ul className="list-disc pl-5 space-y-1 text-sm text-gray-700">
                  <li>Save time on assessment configuration</li>
                  <li>Improve candidate evaluation accuracy</li>
                  <li>Standardise scoring methodology</li>
                  <li>Override settings at the job level when needed</li>
                </ul>
              </div>

              <h3 className="text-lg font-medium text-gray-900 mt-6 mb-3">
                Profiles in the Priority System
              </h3>
              <div className="relative border border-gray-200 rounded-md p-4 bg-gray-50">
                <div className="absolute inset-0 flex items-center justify-center opacity-10">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-32 w-32 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1"
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    ></path>
                  </svg>
                </div>
                <div className="relative z-10">
                  <p className="text-sm text-gray-700 mb-3">
                    Assessment Profiles sit in the middle of the priority
                    system:
                  </p>

                  <ol className="list-decimal pl-5 space-y-2 text-sm text-gray-700">
                    <li className="bg-white p-2 rounded border border-gray-200">
                      <span className="font-medium text-gray-900">
                        Company-wide preferences
                      </span>{" "}
                      provide default settings for all assessments
                    </li>
                    <li className="bg-indigo-50 p-2 rounded border border-indigo-200">
                      <span className="font-medium text-indigo-900">
                        Assessment Profiles
                      </span>{" "}
                      override company preferences with role-specific
                      configurations
                    </li>
                    <li className="bg-white p-2 rounded border border-gray-200">
                      <span className="font-medium text-gray-900">
                        Job-specific settings
                      </span>{" "}
                      override profiles when needed for unique positions
                    </li>
                  </ol>
                </div>
              </div>

              <div className="mt-6 border-t border-gray-200 pt-6">
                <h3 className="text-lg font-medium text-gray-900 mb-3">
                  Example Applications
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="bg-indigo-50 p-3 rounded-md border border-indigo-200">
                    <h4 className="font-medium text-indigo-800 mb-1">
                      Technical Trades
                    </h4>
                    <p className="text-xs text-indigo-700">
                      Electrician profiles test practical knowledge, safety
                      procedures, and code compliance
                    </p>
                  </div>
                  <div className="bg-indigo-50 p-3 rounded-md border border-indigo-200">
                    <h4 className="font-medium text-indigo-800 mb-1">
                      Professional Services
                    </h4>
                    <p className="text-xs text-indigo-700">
                      Accounting profiles focus on technical expertise and
                      attention to detail
                    </p>
                  </div>
                  <div className="bg-indigo-50 p-3 rounded-md border border-indigo-200">
                    <h4 className="font-medium text-indigo-800 mb-1">
                      Healthcare
                    </h4>
                    <p className="text-xs text-indigo-700">
                      Nursing profiles evaluate patient care knowledge and
                      emergency response skills
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-6 text-right">
              <button
                onClick={closeModal}
                className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 mr-1.5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AssessmentProfileAbout;
